// Max email length as defined by RFC 5321.
const MAX_EMAIL_LENGTH = 254;

/**
 * Validates an email address (case-insensitive).
 *
 * Same pattern as Zod's `z.email()`: rejects a leading dot and any consecutive
 * dots, and requires a domain of dot-separated labels ending in a 2+ letter TLD.
 */
export const EMAIL_REGEXP =
  // eslint-disable-next-line no-useless-escape -- kept identical to Zod's z.email() pattern
  /^(?!\.)(?!.*\.\.)([a-z0-9_'+\-\.]*)[a-z0-9_+-]@([a-z0-9][a-z0-9\-]*\.)+[a-z]{2,}$/i;

export const isValidEmail = (email?: string | null): boolean =>
  !!email && email.length <= MAX_EMAIL_LENGTH && EMAIL_REGEXP.test(email);

export const hasNonAsciiChar = (value?: string | null): boolean =>
  !!value && value.split('').some((char) => char.charCodeAt(0) > 127);
